import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { getMaterial, createMaterial, updateMaterialById, deleteMaterialById} from "../api";

const FilterTableMaterial = () => {
  const [Material, setMaterial] = useState([]);
  const [filteredMaterial, setFilteredMaterial] = useState([]);
  const [formData, setFormData] = useState({ id: 0, descripcion: "", unidad: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState("");
  const [filterText, setFilterText] = useState("");

  const fetchMaterial = async () => {
    try {
      const response = await getMaterial();
      setMaterial(response.data);
      setFilteredMaterial(response.data); // Initially show all items
    } catch (error) {
      console.error("Error fetching material:", error);
      setError("Error loading data");
    }
  };

  useEffect(() => {
    fetchMaterial();
  }, []);

  useEffect(() => {
    if (filterText) {
      const filtered = Material.filter((Material) =>
        Material.id.toString().includes(filterText.toLowerCase()) ||
        Material.descripcion.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredMaterial(filtered);
    } else {
      setFilteredMaterial(Material);
    }
  }, [filterText, Material]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await updateMaterialById(formData.id, { descripcion: formData.descripcion, unidad: formData.unidad });
        alert("Material actualizado con éxito.");
      } else {
        await createMaterial(formData);
        alert("Material registrado con éxito.");
      }
      setFormData({ id: 0, descripcion: "", unidad: "" });
      setIsEditing(false);
      fetchMaterial();
    } catch (error) {
      console.error("Error procesando el material:", error);
    }
  };

  const handleEdit = (Material) => {
    setFormData(Material);
    setIsEditing(true);
  };

  const handleClearFilters = () => {
    setIsEditing(false);
    setFormData({ id: 0, descripcion: "", unidad: "" });
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de eliminar esta material?")) {
      try {
        await deleteMaterialById(id);
        alert("Material eliminado con éxito.");
        fetchMaterial();
      } catch (error) {
        console.error("Error eliminando la material:", error);
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <center><h2>{isEditing ? "Editar Material" : "Agregar Material"}</h2></center>
        <div className="input-group">
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            className="input"
            disabled={isEditing}
            hidden
          />
        </div>
        <div className="input-group">
          <label className="label3">Descripción</label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className="input-form-2"
          />
        </div>

        <div className="input-group">

          <label className="label2">Unidad</label>
          <select
            name="unidad"
            value={formData.unidad}
            onChange={handleChange}
            className="input-form-1"
          >

            <option value="pzs">pzs</option>
            <option value="lt">lt</option>
            <option value="gr">gr</option>
            <option value="caja">caja</option>
          </select>
        </div>
        <center>
          <button type="submit" className="button-form-blue">
          {isEditing ? "Actualizar" : "Registrar"}
          </button>
          <button  type="reset" className="button-form-gray" onClick={handleClearFilters}>
              Cancelar
          </button>
        </center>
      </form>
      <hr />
      <div className="input-group">
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por id, descripción..."
          className="input3"
        />
      </div>
      {filteredMaterial.length === 0 ? (
        <p>{error || "Cargando datos..."}</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Descripción</th>
              <th>unidad</th>
              <th colSpan="2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredMaterial.map((Material) => (
              <tr key={Material.id}>
                <td>{Material.id}</td>
                <td>{Material.descripcion}</td>
                <td>{Material.unidad}</td>
                <td>
                  <button onClick={() => handleEdit(Material)} className="button-table-blue">
                    Editar
                  </button>
                </td><td>
                  <button onClick={() => handleDelete(Material.id)} className="button-table-red">
                    Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

FilterTableMaterial.propTypes = {
  material: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
    })
  ),
};

export default FilterTableMaterial;
